export default __webpack_public_path__ + "static/media/chevron.768dac31.svg";